export default "__VITE_ASSET__B7$m7MoM__"